<template>
  <div>关系列表</div>
</template>

<script>
export default {
  name: 'RelationshipList'
}
</script>

<style scoped>
</style>
